import { Component, Input, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { TransporteurDto } from 'src/api/models';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-transporteur',
  templateUrl: './transporteur.component.html',
  styleUrls: ['./transporteur.component.css']
})
export class TransporteurComponent implements OnInit {
  @Select(ControlPanelStore.transporteurs$) transporteurs$: Observable<TransporteurDto[]>;

  private _transporteurId: number = null;
  Transporteurs: TransporteurDto[] = [];

  @Input()
  get transporteurId() {
    return this._transporteurId;
  }
  set transporteurId(val) {
    this._transporteurId = val;
    this.getTransporteurInComponent();
  }

  TransporteurInComponent: string;

  t: Subscription;

  constructor() { }

  ngOnInit() {
    this.t = this.transporteurs$.subscribe(res => {
      if (res != null) {
        this.Transporteurs = res;
        this.getTransporteurInComponent();
      }
    });
  }

  getTransporteurInComponent() {
    let transporteur = this.Transporteurs.find(p => p.Id == this.transporteurId);
    this.TransporteurInComponent = (transporteur) ? transporteur.Identifiant : null;
  }

  ngOnDestroy() {
    this.t?.unsubscribe();
  }

}
